import { render, staticRenderFns } from "./GoBackHeader.vue?vue&type=template&id=9b15f8a8&scoped=true&"
import script from "./GoBackHeader.vue?vue&type=script&lang=ts&"
export * from "./GoBackHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b15f8a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
